import * as React from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import axios from 'axios'; 
import { Icon } from '@blueprintjs/core';

import { Helmet } from "react-helmet";

import './styles';

import Contents from './components/Contents';
import Player from './components/Player';
import TopBar from './components/TopBar';
import Footer from './components/Footer';
import WelcomeDialog from './components/WelcomeDialog';

const API_URL = (window as any).API_URL;
const API_TOKEN = (window as any).API_TOKEN; 
const DEFAULT_EPISODE = 'bonus-dismantling-the-engine';

const ContentsTrigger = ({onClick}) => {
  return (
    <div className="ContentsTrigger" onClick={onClick}>
      <Icon icon="list" />
      Contents
    </div>
  );
}

type VideoCourseAppProps = {
  history: any,
  match: any,
  user: {},
}
class VideoCourseApp extends React.Component<VideoCourseAppProps> {
  state = {
    course: null,
    isLoading: true,
    contentsOpen: false,
  }

  componentWillMount() {
   axios.get(API_URL + '/courses/1', {
     params: { token: API_TOKEN },
   }).then( (response) => {
       this.setState({
         course: response.data.data,
         isLoading: false,
       })
     });
  }

  getCurrentEpisode = () => {
    const { match } = this.props;
    if(!match.params.slug) match.params.slug = DEFAULT_EPISODE;

    return this.findEpisodeBySlug(match.params.slug);
  }

  handleChangeEpisode = (episode) => {
    console.log("Will change episode to ", episode);
    const { history } = this.props;
    history.push(`/video-course/watch/${episode.slug}`)
  }

  handleEpisodeProgress = (position) => {
    console.log("New position is", position);
    axios.post(API_URL + '/episodes/' + this.getCurrentEpisode().id +'/progress', {
      position: position,
      token: API_TOKEN,
    });
  }

  getAllEpisodes = () => {
    const { course } = this.state;
    return [].concat.apply([], course.sections.map( section => section.episodes ));
  }

  toggleContents = () => {
    this.setState({
      contentsOpen: !this.state.contentsOpen,
    });
  }

  findEpisodeBySlug = (slug) => {
    let allEpisodes = this.getAllEpisodes();
    return allEpisodes.find( (episode) => episode.slug.toLowerCase() == slug.toLowerCase() );
  }

  getNextEpisode = () => {
    let allEpisodes = this.getAllEpisodes();
    const currentEpisode = this.getCurrentEpisode();
    var i = allEpisodes.indexOf(currentEpisode);
    return allEpisodes[i+1];
  }

  handleFinishPlaying = () => {
    this.handleChangeEpisode(this.getNextEpisode());
  }

  render() {
    const { isLoading, course, contentsOpen } = this.state;


    if(isLoading) return <p>Loading...</p>;
    
    const currentEpisode = this.getCurrentEpisode();
    const nextEpisode = this.getNextEpisode();
    let className = "VCApp bp3-dark"
    if(contentsOpen) {
      className += " contents-open";
    }

    return (
      <div className={className}>
        <Helmet>
          <title>{currentEpisode.name} - How a Car Works</title>
          <meta property="og:title" content={"Video: "+currentEpisode.name} />
          <meta property="og:image" content={"https://www.howacarworks.com/og-images/Course-Episode/"+currentEpisode.id+".jpg"} />

        </Helmet>

        {!course.owned && <WelcomeDialog />}

        <TopBar current={currentEpisode} user={this.props.user} />
        <div className="_main">
      <ContentsTrigger onClick={this.toggleContents} />
      <Contents course={course} current={currentEpisode} onChange={(episode) => {
        this.setState({contentsOpen: false});
        this.handleChangeEpisode(episode);
      }} />
      <Player episode={currentEpisode} 
        onFinish={this.handleFinishPlaying} 
        onProgress={this.handleEpisodeProgress}
        owned={course.owned} 
        nextEpisode={nextEpisode} />
        </div>
        <Footer />
      </div>
    );
  }
}
type WrappedProps = {
  user: {},
}

export default class WrappedApp extends React.Component<WrappedProps> {
  render() {
    return (
      <Router>
      <Route path="/video-course/watch/:slug?" render={ (props) => <VideoCourseApp {...props} user={this.props.user} /> } />
      </Router>
    );
  }
}
